<template>
  <div
    class="w-full bg-truegray-700 flex flex-col justify-center px-12 md:px-16 lg:px-32 py-28 relative cw__primary-overlay-opac"
  >
    <div class="w-full z-20">
      <h2 class="text-white text-5xl mb-12">Connect with Employees</h2>
      <!-- Loading -->
      <div
        v-if="connectionsLoading"
        class="w-full h-24 flex items-center justify-center"
      >
        <lottie :options="LOADING_ANIMATION_OPTIONS" />
      </div>
      <!-- /Loading -->

      <!-- Connections -->
      <div
        v-else
        class="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-6 z-20"
      >
        <CardConnection
          v-for="connection in connections"
          :key="connection.id"
          :connection="connection"
          context="CW"
        />
      </div>
      <!-- /Connections -->
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from '../../../js/store/index.js'
import * as loadingAnimation from '../../../shared/components/loading-dark.json'
import CardConnection from '../../shared/connections/components/CardConnection.vue'

export default defineComponent({
  name: 'Posts',
  components: { CardConnection },

  setup() {
    const LOADING_ANIMATION_OPTIONS = {
      animationData: loadingAnimation.default,
    }
    const store = useStore()

    const contributor = computed(
      () => store.getters['contributors/getOrganisationProfile'],
    )

    const isDarkMode = ref(false)
    const connectionsLoading = ref(false)
    const connections = computed(
      () => store.getters['contributors/getOrganisationProfileConnections'],
    )

    return {
      LOADING_ANIMATION_OPTIONS,
      isDarkMode,
      contributor,
      connectionsLoading,
      connections,
    }
  },
})
</script>

<style scoped>
.cw__primary-overlay-opac::after {
  z-index: 1;
  width: 100%;
  height: 100%;
  content: '';
  position: absolute;
  inset: 0;
  background: var(--primary);
  opacity: 0.4;
}
</style>
